import apiUrl from "../../../../../utils/settings";

export const reverseGeocodeUrl = () => {
  return apiUrl + '/address/reverse-geocode';
};

export const addressUrl = () => {
  return apiUrl + '/address';
};

export const saveAddressUrl = () => {
  return apiUrl + '/address/add-from-geocode';
};
export const convertAddressToCoordinatesUrl = () => {
  return apiUrl + '/address/geocode-address';
};

export const adressTagUrl = () => {
  return apiUrl + '/address/address-tags';
};

